import { Component, OnInit,Input,TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DeviceBehfa_Interface, Empty_DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { PM_Program_Interface } from 'src/app/Interface/PM_Program_Interface';
import { Empty_PM_Service_Interface, PM_Service_Interface } from 'src/app/Interface/PM_Service_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceBehfaService } from 'src/app/Service/DeviceBehfa/DeviceBehfa.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PM_ProgramService } from 'src/app/Service/PM/PM_Program.service';
import { PM_ServiceService } from 'src/app/Service/PM/PM_Service.service';

@Component({
  selector: 'app-PMServiceForm',
  templateUrl: './PMServiceForm.component.html',
  styleUrls: ['./PMServiceForm.component.scss']
})
export class PMServiceFormComponent implements OnInit {

  @Input() inner_PM: PM_Service_Interface = Empty_PM_Service_Interface()
  Token: String = ""




  constructor(
    private PM_Service_Service: PM_ServiceService,
    private PM_Program_Service: PM_ProgramService,
    private modalService: BsModalService,
    private Nav_Service: NavService,
    private Alertify_Service: AlertifyService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');

    this.PMForm = new FormGroup({
      id: new FormControl(),
      DeviceBehfa_id: new FormControl("", Validators.required),
      Program_id: new FormControl(0, Validators.required),
    })

    this.Nav_Service.CheckValidPage(this.Token, 1159).subscribe(
      data => {

        this.Read_PM_Program()
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )

  }

  //#region PM Program

  DataList_PM_Program: Array<PM_Program_Interface> = []
  Read_PM_Program() {
    this.PM_Program_Service.GetActive(this.Token).subscribe(
      data => {
        this.DataList_PM_Program = data

      }, error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  //#endregion

  //#region  Form

  PMForm: FormGroup;

  get_Form_DeviceBehfa_id() {
    return this.PMForm.get('DeviceBehfa_id') as FormControl;
  }

  get_Form_Program_id() {
    return this.PMForm.get('Program_id') as FormControl;
  }

  //#endregion


  //#region  Device Behfa

  modalRef_DeviceBehfa: any;

  openModal_DeviceBehfa(template: TemplateRef<any>) {
    this.modalRef_DeviceBehfa = this.modalService.show(template);

  }

  DataList_DeviceBehfa:Array<DeviceBehfa_Interface>=[]
  Selected_DataList_DeviceBehfa:DeviceBehfa_Interface=Empty_DeviceBehfa_Interface()

  Set_Selected_DeviceBehfa_Record(item: DeviceBehfa_Interface) {
    this.Selected_DataList_DeviceBehfa = item
    this.get_Form_DeviceBehfa_id().setValue(item.codeBEHFA)
    this.modalRef_DeviceBehfa.hide()
  }

  page:0
  //#endregion

  InProccessing: boolean = false

  SubmitPMForm() {
    if (this.Selected_DataList_DeviceBehfa.id==0) {
      this.Alertify_Service.ErrorMessage("Select Behfa equipment.")
    }
    else if (this.get_Form_Program_id().value=="0") {
      this.Alertify_Service.ErrorMessage("Select the service program.")
    }
    else {
      this.InProccessing = true
      this.PM_Service_Service.AddAddDevice(Number(this.get_Form_Program_id().value),
      this.Selected_DataList_DeviceBehfa.id,
        this.Token).subscribe(
        data => {
          this.InProccessing = false
          if (data.id == -1) {
            this.Alertify_Service.ErrorMessage("This equipment already has the selected service interval.")
          }
          else {


            this.Alertify_Service.SuccessMessage("Information saved successfully.")
          }
        }, error => {
          localStorage.clear()
          location.reload();
        }
      )
    }

  }

}
